import { create } from 'zustand';

function buildTableState() {
  return {
    items: [],
    loading: false,
    error: null,
    paginationData: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10,
      hasNextPage: false,
      hasPreviousPage: false,
    },
    uniqueValues: {},
    columnFilters: {},
    setItems: (items) => ({ items }),
    setLoading: (loading) => ({ loading }),
    setError: (error) => ({ error }),
    clearError: () => ({ error: null }),
    setPaginationData: (paginationData) => ({ paginationData }),
    setUniqueValues: (uniqueValues) => ({ uniqueValues }),
    setColumnFilters: (columnFilters) => ({ columnFilters }),
  };
}

function createReferenceTableStore() {
  return create((set, get) => ({
    ...buildTableState(),
    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setPaginationData: (paginationData) =>
      set({ paginationData: { ...get().paginationData, ...paginationData } }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
  }));
}

export const useRegulatorySourceTableStore = createReferenceTableStore();
export const useRegulatoryClauseTableStore = createReferenceTableStore();
export const useComplianceObligationTableStore = createReferenceTableStore();
export const useComplianceFrameworkTableStore = createReferenceTableStore();
export const useDpiaTemplateTableStore = createReferenceTableStore();
export const useIncidentTemplateTableStore = createReferenceTableStore();
export const useVendorAssessmentTableStore = createReferenceTableStore();
export const useGovernanceReportTableStore = createReferenceTableStore();
export const useReportConfidentialityClassTableStore = createReferenceTableStore();
export const useAutomationDefinitionTableStore = createReferenceTableStore();
export const useRetentionPeriodTableStore = createReferenceTableStore();
export const useInternationalTransferTableStore = createReferenceTableStore();
export const useTransferTypeTableStore = createReferenceTableStore();
export const useRecipientGroupTableStore = createReferenceTableStore();
export const useDataDisposalMethodTableStore = createReferenceTableStore();
export const useDataSourceTableStore = createReferenceTableStore();
export const usePrivacyPrincipleTableStore = createReferenceTableStore();
export const useSecurityMeasureTableStore = createReferenceTableStore();
export const useDutyDefinitionTableStore = createReferenceTableStore();
